import React from "react";
import { Box } from "@mui/material";
// import ReactPlayer from "react-player";
import arkChatLogo from "../assets/images/arkChatLogo.svg";

const ArkchatLogoCard = ({height="calc(100vh - 32px)"}) => {
  // const [isPlaying, setIsPlaying] = useState(false);

  return (
    <>
      {/*  */}
      <Box
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        height={height}
      >
        <Box width={"30%"}>
          <img src={arkChatLogo} alt="arkChat" />
        </Box>

        <Box width={"100%"} position={"absolute"} top={"25%"}>
          <Box
            // onClick={() => (isPlaying ? setIsPlaying(false) : "")}
            // border={"1px solid"}
            height={"21.8rem"}
            width={"100%"}
            position={"relative"}
            // sx={{ cursor: isPlaying ? "pointer" : "" }}
          >
            {/* <ReactPlayer
              width="100%"
              height="95%"
              url={"https://youtu.be/c0eH9TMBsTw"}
              controls={false}
              volume={null}
              muted={false}
              onEnded={() => setIsPlaying(false)}
              playing={isPlaying}
              pip={false}
              config={{
                file: {
                  attributes: {
                    controlsList:
                      "nodownload disablepictureinpicture noplaybackrate",
                  },
                },
              }}
            /> */}
           <img style={{width:"100%",height:"100%"}} src="https://prod-media.arkchat.com/wp-content/uploads/2022/08/about-Logo.svg" alt="arkchat" />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ArkchatLogoCard;
